import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useBoardCrumbs } from '@/features/tarefas/crumbs'
import { QuadroPage } from '@/features/tarefas/QuadroPage'

const searchSchema = z.object({
  card: z.uuid().optional().catch(undefined),
  comment: z.uuid().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/app/tarefas/$boardId')({
  // As colunas rolam por dentro; a página usa a largura e a altura inteiras.
  staticData: { moldura: 'larga', crumb: { useCrumbs: useBoardCrumbs } },
  validateSearch: (search) => searchSchema.parse(search),
  component: function QuadroRoute() {
    const { boardId } = Route.useParams()
    const { card, comment } = Route.useSearch()
    return <QuadroPage boardId={boardId} card={card} comment={comment} />
  },
})
